<template>
  <div>
    <div class="row vs-controls-row">
      <div class="col">
        <div>
          <label for="timer">Minutes</label>
          <b-form-spinbutton
            id="timer"
            v-model="duration"
            :min="0.5"
            :max="50"
            :step="0.5"
            :disabled="running"
            @change="handleDurationChange"
          ></b-form-spinbutton>
        </div>
      </div>

      <div class="col align-self-end">
        <b-button v-if="!running" variant="success" @click="start">
          Start
        </b-button>

        <b-button v-if="running" variant="primary" @click="pause">
          <b-icon icon="pause-fill"></b-icon>
        </b-button>
      </div>

      <div class="col align-self-end text-right">
        <b-button variant="secondary" size="sm" @click="reset">Reset</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { EventBus } from '../../event-bus';

export default {
  data() {
    return {
      duration: 1,
      running: false,
    };
  },

  mounted() {
    EventBus.$on('timer-up', this.reset);
  },

  destroyed() {
    EventBus.$off('timer-up', this.reset);
  },

  watch: {
    running(val) {
      EventBus.$emit('timer-state', val);
    },
  },

  computed: {
    ...mapState(['visualScheduleChannel', 'userId']),
  },

  methods: {
    checkRemoteScheduleUpdate(type, value) {
      if (this.visualScheduleChannel) {
        this.visualScheduleChannel.send({
          type,
          value,
          id: this.userId,
        });
      }
    },

    handleDurationChange() {
      this.running = false;
      EventBus.$emit('timer-duration', this.duration * 60);
      this.checkRemoteScheduleUpdate('timer_duration', this.duration * 60);
    },

    pause() {
      this.running = false;
      this.checkRemoteScheduleUpdate('paused', true);
    },

    reset() {
      this.running = false;
      EventBus.$emit('timer-reset');
      this.checkRemoteScheduleUpdate('timer_reset', true);
    },

    start() {
      this.running = true;
      this.checkRemoteScheduleUpdate('timer_start', true);
    },
  },
};
</script>
